import { render } from "./languages.html?vue&type=template&id=74a39263&scoped=true&ts=true"
import script from "./languages.ts?vue&type=script&lang=ts"
export * from "./languages.ts?vue&type=script&lang=ts"

import "./languages.scss?vue&type=style&index=0&id=74a39263&lang=scss&scoped=true"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a39263"]])

export default __exports__